export default {
  'form.title': 'Form List',
  'config.searchForm': 'Search Form',
  'config.form.isInitialForm': 'Initial Form?',
  'config.form.isHeaderDetailsVisible': 'Header Details Visible?',
  'config.form.isVisibleInDetails': 'Visible in Request Detail view?',
};
